import { render, staticRenderFns } from "./RiskAssessment.vue?vue&type=template&id=c7e56f60&scoped=true"
import script from "./RiskAssessment.vue?vue&type=script&lang=ts"
export * from "./RiskAssessment.vue?vue&type=script&lang=ts"
import style0 from "./RiskAssessment.vue?vue&type=style&index=0&id=c7e56f60&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7e56f60",
  null
  
)

export default component.exports